import React, { useState, useCallback } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Alert, Dialog } from "@mui/material";
import "./styles.css";
import { makeStyles } from "@mui/styles";
import Locales from "../../locales";
import { STUDENT_NAME } from "../../constants/textFieldMaxLengths";
import { ALPHABET_REGEX, EMAIL_REGEX } from "../../constants/Regex";
import { sanitizeInputObject } from "../../utils/sanitize";

const useStyles = makeStyles({
  addButton: {
    height: "50px",
    fontSize: "1rem",
  },
  closeButton: {
    height: "50px",
    fontSize: "1rem",
  },
});

const Modal = ({
  closeModal,
  modalVisible,
  onAddUser,
  newStudent,
  setNewStudent,
}) => {
  const styles = useStyles();
  const [validationError, setValidationError] = useState("");
  const submitFormHandler = (event) => {
    setValidationError("");
    event.preventDefault();

    const sanitizedInput = sanitizeInputObject(newStudent);

    if (!sanitizedInput.emailId) {
      return setValidationError(
        Locales.t("is_required").replace("{{prop}}", "Email"),
      );
    }

    if (!sanitizedInput.name) {
      return setValidationError(
        Locales.t("is_required").replace("{{prop}}", "Name"),
      );
    }

    if (!sanitizedInput.emailId.match(EMAIL_REGEX)) {
      return setValidationError(Locales.t("please_enter_valid_email_address"));
    }

    if (!ALPHABET_REGEX.test(sanitizedInput.name)) {
      return setValidationError(
        Locales.t("name_should_only_contain_alphabets"),
      );
    }

    setNewStudent(sanitizeInputObject);
    return onAddUser();
  };

  const handleNameChange = useCallback((e) => {
    if (e.target.value.length > STUDENT_NAME) return;
    setNewStudent((value) => ({ ...value, name: e.target.value }));
  }, []);

  // const onChangeHandler = (event) => {
  //   setNewStudent({ [event.target.name]: event.target.value });
  // };

  return (
    <>
      <Dialog open={modalVisible} onClose={closeModal}>
        <div className="modal-container">
          <div className="modal-header">
            <h2>{Locales.t("add_student")}</h2>
          </div>

          <div className="modal-body">
            <div className="alert-error">
              {validationError && (
                <Alert severity="error">{validationError}</Alert>
              )}
            </div>
            <form onSubmit={submitFormHandler}>
              <div>
                <TextField
                  className="input"
                  label={Locales.t("email")}
                  name="emailId"
                  value={newStudent.emailId}
                  onChange={(e) =>
                    setNewStudent((value) => ({
                      ...value,
                      emailId: e.target.value,
                    }))
                  }
                />
                <TextField
                  type="text"
                  className="input"
                  label={Locales.t("name")}
                  name="name"
                  maxLength={STUDENT_NAME}
                  helperText={`${newStudent.name.length}/${STUDENT_NAME}`}
                  value={newStudent.name}
                  onChange={handleNameChange}
                />
              </div>
              <div className="modal-form-controls">
                <div className="modal-close-button">
                  <Button
                    className={styles.closeButton}
                    onClick={closeModal}
                    variant="contained"
                    color="error">
                    {Locales.t("cancel")}
                  </Button>
                </div>
                <div className="modal-sucess-button">
                  <Button
                    className={styles.addButton}
                    type="submit"
                    variant="contained"
                    color="success">
                    {Locales.t("add")}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default Modal;
